import { createSvgIcon } from '@mui/material';

const VideoIcon = (props) => {
  const IconCmp = createSvgIcon(
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.2011 0.333496H5.63227C4.96146 0.333486 4.40782 0.333478 3.95683 0.370325C3.48841 0.408596 3.05783 0.490733 2.65338 0.696809C2.02617 1.01639 1.51624 1.52632 1.19666 2.15353C0.990585 2.55798 0.908448 2.98856 0.870177 3.45698C0.83333 3.90797 0.833338 4.4616 0.833349 5.1324V8.86791C0.833338 9.53872 0.83333 10.0924 0.870177 10.5434C0.908448 11.0118 0.990585 11.4424 1.19666 11.8468C1.51624 12.474 2.02617 12.9839 2.65338 13.3035C3.05783 13.5096 3.48841 13.5917 3.95683 13.63C4.40782 13.6669 4.96146 13.6668 5.63227 13.6668H10.2011C10.8719 13.6668 11.4255 13.6669 11.8765 13.63C12.345 13.5917 12.7755 13.5096 13.18 13.3035C13.8072 12.9839 14.3171 12.474 14.6367 11.8468C14.8428 11.4424 14.9249 11.0118 14.9632 10.5434C14.9974 10.125 14.9998 9.61844 15 9.01194L16.628 10.6399C16.7873 10.7992 16.9438 10.9559 17.0811 11.0708C17.2035 11.1733 17.4614 11.3789 17.8186 11.407C18.2175 11.4384 18.6073 11.2769 18.8672 10.9727C19.0999 10.7002 19.1369 10.3725 19.1509 10.2134C19.1668 10.0351 19.1667 9.81366 19.1667 9.58835V4.41188C19.1667 4.18658 19.1668 3.9651 19.1509 3.7868C19.1369 3.62772 19.0999 3.30001 18.8672 3.02755C18.6073 2.72329 18.2175 2.56182 17.8186 2.59322C17.4614 2.62133 17.2035 2.82692 17.0811 2.92943C16.9438 3.04433 16.7873 3.20094 16.628 3.36027L15 4.98827C14.9998 4.38182 14.9974 3.87526 14.9632 3.45698C14.9249 2.98856 14.8428 2.55798 14.6367 2.15353C14.3171 1.52632 13.8072 1.01639 13.18 0.696809C12.7755 0.490733 12.345 0.408596 11.8765 0.370325C11.4255 0.333478 10.8719 0.333486 10.2011 0.333496Z"
        fill="#42A5F5"
      />
    </>,
    'VideoIcon',
  );
  return (
    <IconCmp
      style={{ fill: 'none' }}
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      {...props}
    />
  );
};
export default VideoIcon;
